import { render } from "./AusenciasSection.vue?vue&type=template&id=30265866&scoped=true"
import script from "./AusenciasSection.vue?vue&type=script&lang=js"
export * from "./AusenciasSection.vue?vue&type=script&lang=js"

import "./AusenciasSection.vue?vue&type=style&index=0&id=30265866&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30265866"]])

export default __exports__